// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';
import cx from 'classnames';
import _ from 'lodash';
import moment from 'moment';

// utilities
import { fullDate } from '../../../../lib/prettyDate';
import prettyTime from '../../../../lib/prettyTime';
import fixLines from '../../../../lib/fixLines';


export default function EventsList(props) {

  function click(selectedItem) {
    props.handleClick(selectedItem);
  }

  return (
    <ol
      data-id='Event List'
      className='event-list'
    >
      {
        props.list.map((event, eventIndex) =>
          <div
            data-id={`Event List Item ${eventIndex}`}
            className={cx('event-list-item', {'note-item': _.isNil(event.taskTypeId) === 'note', 'task-item': !_.isNil(event.taskTypeId)})}
            key={eventIndex}
          >
            <div
              className='event-status'
              style={{
                backgroundColor: event.color || '#4a4a4a'
              }}
            />
            <div className='event-timestamp'>
              <div data-id='Event Date'
                className='event-date noTextSelect'
                dangerouslySetInnerHTML={{__html: fullDate(new Date(event.dateCreated))}}
              />
              <div>
                {event.taskTypeName && event.taskTypeName}
              </div>
              {
                !_.isNil(event.taskTypeId)
                &&
                <div data-id='Task Status'
                  className='task-status noTextSelect'
                >
                {event.closed ? 'Closed' : 'Open'}
                </div>
              }
            </div>
            <div className='event-content'>
              <div
                data-id='Event Title'
                className='event-title noTextSelect'
                onClick={click.bind(this, event)}
              >
                {!_.isNil(event.taskTypeId) ?  `${event.taskResultName ? event.taskResultName : ''} (${prettyTime(new Date(event.dateCreated))})` : `${event.category || ''} Notes`}
              </div>
              <div
                data-id='Event Description'
                className='event-description noTextSelect'
              >
                {!_.isNil(event.taskFollowUpDate) ? `Follow up on ${moment(event.taskFollowUpDate).format('L')}` : ''}
              </div>
              <div
                data-id='Note Sub-Description'
                className='note-details noTextSelect'
              >
                {!_.isNil(event.taskTypeId) ? fixLines(event.message) : fixLines(event.note)}
              </div>
            </div>
          </div>
        )
      }
    </ol>
  );
}

EventsList.propTypes = {
  list: PropTypes.array,
  state: PropTypes.object,
  category: PropTypes.string
};

EventsList.defaultProps = {
  list: [],
  state: {}
};



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/r_Events/f_EventsList/index.js